/**
 * Copyright (c) HashiCorp, Inc.
 */

import { hash, get } from '@ember/helper';
import { HdsDropdown } from '@hashicorp/design-system-components/components';

import FilterBarSortCheckmark from './sort/checkmark.gts';

import type { TOC } from '@ember/component/template-only';
import type { ComponentLike, WithBoundArgs } from '@glint/template';
import type { FilterConfig } from '../filter-bar';
import type { HdsDropdownSignature } from '@hashicorp/design-system-components/components/hds/dropdown/index';

export interface FilterBarSortSignature {
  Args: {
    config: FilterConfig;
    onSortChange: (key: string, value: string) => void;
    dropdown?: ComponentLike<HdsDropdownSignature>;
  };
  Blocks: {
    default: [
      {
        Checkmark?: WithBoundArgs<
          typeof FilterBarSortCheckmark,
          'checkmark' | 'config' | 'onSortChange'
        >;
      },
    ];
  };
  Element: HTMLDivElement;
}

const FilterBarSort: TOC<FilterBarSortSignature> = <template>
  {{#if @dropdown}}
    {{#let @dropdown as |Dropdown|}}
      <Dropdown ...attributes as |DD|>
        <DD.ToggleButton
          @icon="sort-desc"
          @text="Sort by: {{get @config 'sort.text'}}"
          @color="secondary"
          data-test-sort-button
        />
        {{yield
          (hash
            Checkmark=(component
              FilterBarSortCheckmark
              checkmark=DD.Checkmark
              config=@config
              onSortChange=@onSortChange
            )
          )
        }}
      </Dropdown>
    {{/let}}
  {{else}}
    <HdsDropdown ...attributes as |DD|>
      <DD.ToggleButton
        @icon="sort-desc"
        @text="Sort by: {{get @config 'sort.text'}}"
        @color="secondary"
        data-test-sort-button
      />
      {{yield
        (hash
          Checkmark=(component
            FilterBarSortCheckmark
            checkmark=DD.Checkmark
            config=@config
            onSortChange=@onSortChange
          )
        )
      }}
    </HdsDropdown>
  {{/if}}
</template>;

export default FilterBarSort;
